<template>
  <div class="EnvironmentAttention">
    <div class="textArea">
      推奨環境でアクセスしてください。
    </div>
    <sub-btn @click="onHome()">プリクラONのホームに戻る</sub-btn>
  </div>
</template>

<script>
import SubBtn from '../components/SubBtn.vue'
export default {
  components: { SubBtn },
  mixins: [],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    onHome() {
      this.$router.push('/')
    },
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.EnvironmentAttention {
  padding-top: 30px;
}
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
